<div class="auth-container">
  <!-- Main Content Card -->
  <div class="main-card">
    <!-- Branding Header -->
    <div class="branding-header">
      <div class="logo-container">
        <img src="https://supersee.io/wp-content/uploads/2025/02/Supersee_Logo-1.webp" alt="SuperSee Logo" class="logo">
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-section">
      <div class="loading-container">
        <div class="spinner-wrapper">
          <div class="spinner-ring spinner-ring-1"></div>
          <div class="spinner-ring spinner-ring-2"></div>
          <div class="spinner-ring spinner-ring-3"></div>
          <div class="spinner-center">
            <div class="spinner-dot"></div>
          </div>
        </div>
      </div>

      <h2 class="loading-text">Signing You In</h2>
      <p class="loading-subtext">Please wait while we securely connect to your account</p>

      <!-- Loading Steps -->
      <div class="loading-steps">
        <div *ngFor="let step of loadingSteps; let i = index" 
             class="step-item"
             [class.completed]="step.completed"
             [class.active]="i === currentStepIndex && !step.completed"
             [class.pending]="i > currentStepIndex">
          <div class="step-icon">
            <span *ngIf="step.completed" class="check-icon">✓</span>
            <span *ngIf="!step.completed" class="step-emoji">{{ step.icon }}</span>
          </div>
          <span class="step-text">{{ step.text }}</span>
          <div *ngIf="i === currentStepIndex && !step.completed" class="step-loader">
            <div class="dot-flashing"></div>
          </div>
        </div>
      </div>

      <div class="progress-indicator">
        <div class="progress-bar">
          <div class="progress-fill" [style.animation-duration]="'6s'"></div>
        </div>
      </div>
    </div>
  </div>
</div>